import { render, staticRenderFns } from "./RequestResetPasswordPage.vue?vue&type=template&id=5e8a7bba&scoped=true&"
import script from "./RequestResetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./RequestResetPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./RequestResetPasswordPage.vue?vue&type=style&index=0&id=5e8a7bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8a7bba",
  null
  
)

export default component.exports